<template>
  <div class="user-container">
    <el-dialog :title="operateType === 'add' ? '添加域名' : '编辑域名'" :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="formData" ref="domainForm" :rules="rules" :inline="inline" status-icon style="width: 500px; margin-left: 50px" label-width="120px" label-position="">
        <el-form-item label="域名" prop="d_domainname">
          <el-input v-model.trim="formData.d_domainname" :readonly="readonly" size="small" placeholder="请输入域名" />
        </el-form-item>
        <el-form-item label="所有者" prop="owner">
          <treeselect
            v-model="formData.owner"
            :multiple="true"
            :clearable="false"
            :normalizer="normalizer"
            :options="ownerOptions"
            @input="ownerValidate"
            placeholder="请选择所有者"
          />
        </el-form-item>
        <el-form-item label="注册时间" prop="register_time">
          <el-date-picker v-model="formData.register_time" type="date" placeholder="选择日期" @change="dateChange"> </el-date-picker>
        </el-form-item>
        <el-form-item label="注册平台" prop="d_platform">
          <el-input v-model="formData.d_platform" size="small" placeholder="请输入注册平台" />
        </el-form-item>
        <el-form-item label="cloudflare帐号" prop="d_cloudflare_email">
          <el-input v-model.trim="formData.d_cloudflare_email" size="small" :disabled="isNotOnline" placeholder="请输入cloudflare帐号,邮箱" />
        </el-form-item>
        <el-form-item label="服务器IP" prop="d_vpsip">
          <el-input v-model.trim="formData.d_vpsip" size="small" :disabled="isNotOnline" placeholder="请输入服务器IP" />
        </el-form-item>
        <el-form-item label="是否上站" size="small" prop="state">
          <el-switch v-model="formData.state" @change="checkIsOnline" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="resetForm">取 消</el-button>
          <el-button size="small" type="primary" @click="submitForm('domainForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="filter-container">
      <el-input
        v-perm="['/inquiry/domain/view']"
        placeholder="按域名查找"
        prefix-icon="el-icon-search"
        size="small"
        clearable
        v-model="filters[0].value"
        style="width: 160px;margin-right: 10px"
        class="filter-item"
      />
      <el-input
        placeholder="按所属人查找"
        v-model="filters[1].value"
        prefix-icon="el-icon-search"
        size="small"
        clearable
        style="width: 160px;margin-right: 10px"
        class="filter-item"
        v-if="userinfo['uid'] === '1'"
      />
      <el-select v-perm="['/inquiry/domain/view']" clearable class="filter-item" style="width: 160px;" size="small" placeholder="是否上站" v-model="filters[2].value">
        <el-option label="已上站" value="1" />
        <el-option label="未上站" value="0" />
      </el-select>
      <el-date-picker
        v-model="filters[3].value"
        type="daterange"
        align="right"
        size="small"
        unlink-panels
        value-format="timestamp"
        range-separator="-"
        start-placeholder="注册日期"
        end-placeholder="注册日期"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerOptions"
        style="margin-left: 10px"
      >
      </el-date-picker>
      <el-button v-perm="['/inquiry/domain/add']" class="filter-item" style="margin-left: 10px;" size="mini" type="primary" icon="el-icon-plus" @click="handleDomainAdd"
        >添加</el-button
      >
    </div>
    <data-tables-server
      ref="multipleTable"
      :data="data"
      :total="total"
      :filters="filters"
      :table-props="tableProps"
      :loading="loading"
      :page-size="5"
      :pagination-props="{ background: true, pageSizes: [5, 10, 20] }"
      layout="table,pagination"
      @query-change="fetchData"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="d_id" label="ID" sortable="custom">
        <template slot-scope="scope">
          <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom" show-overflow-tooltip />
      <el-table-column label="是否上站" align="center" min-width="100px" prop="state">
        <template slot-scope="scope">
          <el-tag :type="scope.row.state | stateFilter(scope.row.state)" size="small">{{ scope.row.state | stateShowFilter(scope.row.state) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-button v-perm="['/inquiry/domain/edit']" :size="btnsize" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-perm="['/inquiry/domain/del']" :size="btnsize" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </data-tables-server>
    <div style="margin-top: -34px">
      <el-button type="danger" :disabled="hiddenButton" icon="el-icon-delete" size="small" @click="deleteSelection()">删除选中行</el-button>
      <el-button type="primary" :disabled="hiddenButton" :loading="downLoading" icon="el-icon-download" size="small" @click="exportSelection()">导出选择项</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import { DataTablesServer } from "vue-data-tables"
Vue.use(DataTablesServer)

//import perm权限
import perm from "@/directive/permission/index.js" // 权限判断指令

// import the component
import Treeselect from "@riophae/vue-treeselect"
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
//import { createUser, updateUser, deleteUser, getUserList, getRoleOptions } from "@/api/user"
import { getDomainList, getOwnerOptions, createDomain, updateDomain, deleteDomain } from "@/api/domain"

export default {
  components: { Treeselect },
  directives: { perm },
  name: "User",
  filters: {
    stateFilter(status) {
      const stateMap = {
        true: "success",
        false: "danger"
      }
      return stateMap[status]
    },
    stateShowFilter(status) {
      const stateShowMap = {
        true: "已上站",
        false: "未上站"
      }
      return stateShowMap[status]
    }
  },
  data() {
    return {
      userinfo: {},
      ownerOptions: [],
      //自定义id,label
      normalizer(node) {
        return {
          id: node.uid,
          label: node.username
          //children: node.children
        }
      },
      defaultQueryInfo: "",
      currentPage: 1,
      pageSize: 5,
      downLoading: false,
      inline: false,
      readonly: false,
      hiddenButton: true,
      selectedRows: [],
      dialogFormVisible: false,
      operateType: "add",
      formData: {
        d_domainname: "",
        d_vpsip: "",
        d_platform: "",
        owner: [],
        d_cloudflare_email: "",
        register_time: "",
        state: false
      },
      rules: {
        d_domainname: [{ required: true, message: "请输入域名", trigger: "blur" }],
        owner: [{ required: true, message: "请选择所属人", trigger: "input" }],
        register_time: [{ required: true, message: "请填写注册时间", trigger: "blur" }],
        d_platform: [{ required: true, message: "请填写注册平台", trigger: "blur" }]
      },
      data: [],
      titles: [
        // {
        //   prop: "d_id",
        //   label: "ID"
        // },
        {
          prop: "d_domainname",
          label: "域名"
        },
        {
          prop: "d_owner",
          label: "所属人"
        },
        {
          prop: "register_time",
          label: "注册时间"
        },
        {
          prop: "d_platform",
          label: "注册平台"
        },
        {
          prop: "d_vpsip",
          label: "服务器IP"
        },
        {
          prop: "d_cloudflare_email",
          label: "cloudflare帐号"
        }
      ],
      btnsize: "mini",
      tableProps: {
        border: true,
        stripe: true,
        highlightCurrentRow: true,
        defaultSort: {
          prop: "d_id",
          order: "descending"
        }
      },
      loading: false,
      total: 1,
      //过滤发生在后台
      filters: [
        {
          prop: "d_domainname",
          value: ""
        },
        {
          prop: "d_owner",
          value: ""
        },
        {
          //是否上站
          prop: "state",
          value: ""
        },
        {
          prop: "register_time",
          value: ""
        }
      ],
      isNotOnline: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const start = new Date(new Date()).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              //console.log(start, end)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000)).getTime()
              const end = start + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "最近7天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 7 * 60 * 60 * 1000)).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)).getTime()
              const end = new Date(new Date()).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: "当前月份",
            onClick(picker) {
              const now = new Date()
              var nowMonth = now.getMonth() //当前月
              var nowYear = now.getFullYear() //当前年
              //本月的开始时间
              var monthStartDate = new Date(new Date(nowYear, nowMonth, 1)).getTime()
              //本月的结束时间
              var monthEndDate = new Date(new Date(nowYear, nowMonth + 1, 0)).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [monthStartDate, monthEndDate])
            }
          },
          {
            text: "上个月份",
            onClick(picker) {
              const now = new Date()
              var preMonth = now.getMonth() - 1 //上个月
              var nowYear = now.getFullYear() //当前年
              //上个月的开始时间
              var monthStartDate = new Date(new Date(nowYear, preMonth, 1)).getTime()
              //上个月的结束时间
              var monthEndDate = new Date(new Date(nowYear, preMonth + 1, 0)).getTime() + 24 * 60 * 60 * 1000 - 1
              picker.$emit("pick", [monthStartDate, monthEndDate])
            }
          }
        ]
      }
    }
  },
  created() {
    this.initOwnerOptions()
    this.userinfo = JSON.parse(localStorage.getItem("user_info"))
  },
  methods: {
    dateChange() {
      //alert(val.toString())
    },
    deleteSelection() {
      if (this.selectedRows.length > 0) {
        this.$confirm("此操作将永久删除这些域名, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          console.log(this.selectedRows)
          let tempDataArray = []
          this.selectedRows.forEach(ele => {
            const tempData = {
              domain_id: ele["d_id"]
            }
            tempDataArray.push(tempData)
          })

          deleteDomain(tempDataArray).then(res => {
            if (res.type === "success") {
              this.fetchData()
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        })
      }
    },
    exportSelection() {
      if (this.selectedRows.length) {
        this.downLoading = true
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["域名", "域名所属人", "注册时间", "注册平台", "服务器IP", "cloudflare帐号"]
          const filterVal = ["d_domainname", "d_owner", "register_time", "d_platform", "d_vpsip", "d_cloudflare_email"]
          const list = this.selectedRows
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "Domains"
          })
          setTimeout(() => {
            this.downLoading = false
            this.$refs.multipleTable.$refs.elTable.clearSelection()
          }, 800)
        })
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.hiddenButton = false
        this.selectedRows = val
      } else {
        this.hiddenButton = true
      }
    },
    checkIsOnline() {
      this.isNotOnline = !this.isNotOnline
    },
    ownerValidate() {
      // 这里应该用单框的，这里不想改了
      if (this.formData.owner.length > 1) {
        this.formData.owner = []
      }
      this.$refs.domainForm.clearValidate()
    },
    resetformData() {
      this.formData = {
        d_domainname: "",
        d_vpsip: "",
        d_platform: "",
        owner: [],
        d_cloudflare_email: "",
        register_time: "",
        state: false
      }
    },
    initOwnerOptions() {
      getOwnerOptions().then(res => {
        this.ownerOptions = res.data
        //console.log(res.data)
      })
    },
    handleDomainAdd() {
      //reset formData
      //console.log("i am here")
      //清除上一次add或者update的数据
      this.dialogFormVisible = true
      this.resetformData()
      this.operateType = "add"
      //这时候dom还没有更新完成，因为这些代码都是在主线程中执行的，而vue中设计的dom更新发生在异步队列
      //this.$refs.userForm.clearValidate()
      if (this.formData.state) {
        this.isNotOnline = false
      } else {
        this.isNotOnline = true
      }
      this.$nextTick(() => {
        //这里的回调函数在dom更新后调用
        //清除上一次的验证规则
        this.$refs.domainForm.clearValidate()
      })
    },
    handleUpdate(rowdata) {
      this.operateType = "edit"
      this.dialogFormVisible = true
      //console.log(rowdata)
      this.formData = Object.assign({}, rowdata)
      //console.log(rowdata)
      //this.$refs.userForm.clearValidate()
      if (this.formData.state) {
        this.isNotOnline = false
      } else {
        this.isNotOnline = true
      }
      this.$nextTick(() => {
        //清除在add的时候的验证规则
        this.$refs.domainForm.clearValidate()
      })
    },
    handleDelete(rowdata) {
      this.$confirm("此操作将永久删除域名 : [" + rowdata.d_domainname + "] ， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //json传到php转为关联数组
          const tempData = {
            domain_id: rowdata.d_id,
            domain_name: rowdata.d_domainname
          }
          deleteDomain(tempData).then(res => {
            if (res.type === "success") {
              this.fetchData()
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          })
        })
    },
    //每次过滤，排序都会触发这个函数调用
    fetchData(queryInfo) {
      //console.log("gaga:" + queryInfo.type)
      if (!queryInfo) {
        queryInfo = this.defaultQueryInfo
      }
      if (queryInfo.type === "init") {
        this.defaultQueryInfo = queryInfo
      }
      this.currentPage = queryInfo.page
      this.pageSize = queryInfo.pageSize
      //this.currentPage = queryInfo.page
      //console.log(this.currentPage, queryInfo.page)
      //;(queryInfo.type === "page" || queryInfo.type === "size") && this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}`)
      this.loading = true
      //console.log(queryInfo)
      getDomainList(queryInfo).then(res => {
        this.data = res.data.items
        //在这里处理一下时间格式
        var _self = this
        this.data.map(function(item) {
          item.register_time = _self.formatDate(item)
          return item
        })
        this.total = res.data.total
        this.loading = false
      })
    },
    formatDate(rowData) {
      let date = new Date(parseInt(rowData.register_time) * 1000)
      let Y = date.getFullYear() + "-"
      let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-"
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      //let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":"
      //let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":"
      //let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.operateType === "add") {
            console.log(this.formData)
            createDomain(this.formData).then(res => {
              this.fetchData()
              this.dialogFormVisible = false
              this.$notify({
                type: res.type,
                message: res.message
              })
            })
          } else if (this.operateType === "edit") {
            updateDomain(this.formData).then(res => {
              this.fetchData()
              this.dialogFormVisible = false
              this.$notify({
                type: res.type,
                message: res.message
              })
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      //this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    }
  }
}
</script>

<style lang="scss">
.user-container {
  margin-top: 30px;
  .filter-container {
    margin-bottom: 30px;
  }
}
.pagination-wrap {
  margin-top: 10px;
  text-align: center;
}
.el-date-editor--daterange.el-input__inner {
  width: 220px;
}
</style>
